module.exports = __webpack_public_path__ + "viasat-sport-ac1e4a57680feb208b05b376dff5684e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/viasat-sport.jpg
// module id = 1061
// module chunks = 0 1